import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import { FieldArray } from 'formik';

import { FsButton } from '~/components/core';
import CollapsibleWrapper from '~/components/core/Collapsible/CollapsibleWrapper';
import QuestionItem from '~/components/SystemConfiguration/Communications/PhoneConfigurationTab/PhoneConfigurations/PhoneSurveyConfiguration/EditPhoneSurveyConfigDialog/components/QuestionItem';
import { FORM_IDS } from '~/components/SystemConfiguration/Communications/PhoneConfigurationTab/PhoneConfigurations/PhoneSurveyConfiguration/utils/constants';
import { getEmptyQuestion } from '~/components/SystemConfiguration/Communications/PhoneConfigurationTab/PhoneConfigurations/PhoneSurveyConfiguration/utils/helpers';
import type {
  PhoneSurveyConfigurationModel,
  PhoneSurveyConfigurationModelPhoneSurveyQuestionConfigurationModel,
} from '~/server_shared/openapi/data-contracts';

interface QuestionsSectionProps {
  values: PhoneSurveyConfigurationModel;
  configuration?: PhoneSurveyConfigurationModel;
  setFieldValue: (field: string, value: unknown) => void;
  setAllowSavingWithoutNewFiles: React.Dispatch<
    React.SetStateAction<{
      welcome: boolean;
      response_line: boolean;
      illegal: boolean;
      ending: boolean;
      questions: boolean[];
    }>
  >;
}

const QuestionsSection: React.FC<QuestionsSectionProps> = ({
  values,
  configuration,
  setFieldValue,
  setAllowSavingWithoutNewFiles,
}) => {
  return (
    <div className="mb-20">
      <CollapsibleWrapper
        title="Set survey questions"
        subtitle="Configure up to 5 multiple-choice questions with up to 5 answer options each."
        defaultState={false}
        backgroundColor={CollapsibleWrapper.BACKGROUND_COLOR.WHITE}
        actionCard
        noDivider
        unmountOnExit={false}
      >
        <FieldArray name={FORM_IDS.QUESTIONS}>
          {({ remove, push }) => (
            <div>
              {values?.questions?.map(
                (
                  question: PhoneSurveyConfigurationModelPhoneSurveyQuestionConfigurationModel,
                  questionIndex: number
                ) => (
                  <QuestionItem
                    key={questionIndex}
                    question={question}
                    questionIndex={questionIndex}
                    configuration={configuration}
                    onRemove={remove}
                    setFieldValue={setFieldValue}
                    setAllowSavingWithoutNewFiles={() => {
                      setFieldValue(
                        `${FORM_IDS.QUESTIONS}.${questionIndex}.question_configuration.stored_file_id`,
                        undefined
                      );
                      setFieldValue(
                        `${FORM_IDS.QUESTIONS}.${questionIndex}.question_configuration.permanent_audio_file_url`,
                        undefined
                      );
                      setAllowSavingWithoutNewFiles((prev) => {
                        const newQuestions = [...prev.questions];
                        newQuestions[questionIndex] = false;
                        return { ...prev, questions: newQuestions };
                      });
                    }}
                  />
                )
              )}

              {values.questions && values.questions.length < 5 && (
                <FsButton color={FsButton.COLORS.primary} onClick={() => push(getEmptyQuestion())}>
                  <AddIcon />
                  Add Question
                </FsButton>
              )}
            </div>
          )}
        </FieldArray>
      </CollapsibleWrapper>
    </div>
  );
};

export default QuestionsSection;
